import { useSelector, useDispatch } from 'react-redux'
import uuid from "react-uuid";
import useWindowDims from "../hooks/WindowDims";

const StopsToolTip = (props) => {
 
  return (<div
    style={{
      position: "absolute",
      top: props.tooltip.y,
      left: props.tooltip.x,
      backgroundColor: "#fff",
      opacity: 0.9,
      padding: "10px",
      color: "black",
      zIndex: 9999,
      justifyContent: "right",
      textAlign: "right",
      direction: "rtl",
      fontSize: "1.0em",
      maxWidth: "50vh"
    }}  >

    <b>{`תחנת ${props.tooltip.data.name}`}</b> 
    <br/>
    <b>{`מק"ט: `}</b>{props.tooltip.data.makat}

  </div>

  );
}

export default StopsToolTip;